import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { forwardRef } from 'react';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useFormAutoFocus } from '~/hooks/useFormAutoFocus';
import { SearchArticlesFormMainSection } from './SearchArticlesFormMainSection';

export type ISearchArticlesFormBodyValues = {
  text?: string;
  published?: boolean;
  trashed?: boolean;
};

export type ISearchArticlesFormBodyProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ISearchArticlesFormBodyValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<ISearchArticlesFormBodyValues>;
    onSubmit?: SubmitHandler<ISearchArticlesFormBodyValues>;
    loading?: boolean;
  };

export const SearchArticlesFormBody = forwardRef<
  HTMLFormElement,
  ISearchArticlesFormBodyProps
>(function SearchArticlesForm(props, ref) {
  const { sx, defaultValues, onSubmit, loading, ...other } = props;
  const form = useForm<ISearchArticlesFormBodyValues>({
    defaultValues,
  });
  useFormAutoFocus({ form, name: 'text' });

  return (
    <ContentBlock.FormBody
      ref={ref}
      sx={sx}
      form={form}
      onSubmit={onSubmit}
      hideActionBar
      {...other}
    >
      <SearchArticlesFormMainSection form={form} loading={loading} />
    </ContentBlock.FormBody>
  );
});
